import { SyncOutlined } from '@ant-design/icons';
import { updateLangeNetPrice } from 'api/mall';
import useRateAndSellCount from 'hooks/useRateAndSellCount';
import { PriceContext } from 'libs/contexts';
import { NetPriceSourceEnum } from 'libs/enums';
import { ProductBuyStatusEnum } from 'libs/types';
import { dateFormat } from 'libs/utils';
import { Fragment, useContext, useState } from 'react';
import { Button } from 'react-vant';
import CalculatePriceDetailWithIcon from '@/comps/CalculatePriceDetailWithIcon';
import ProductDetailSalePrice from './ProductDetailSalePrice';
import TradeAgreementPicker from '@/comps/TradeAgreementPicker';
import { splitNum } from '@/libs/utils';

function ProductDetailBasic({
  name,
  promotionTitle,
  isNotInArea = false,
  taxRate,
  unitName,
  supplierSysNo,
  tradeAgreementEntityList = [],
  priceWithoutTax,
  skuDetail,
  skuForPriceCalculate = null,
  choosen = '',
  tradeAgreementSysNo,
  selectTradeAgreement,
  selectNetPriceType,
  productStatus,
  onSelectAgreement,
  onUpdateProduct,
  sellCountString,
  isBuyable,
  isOutSide,
}: {
  name?: string;
  thirdName?: string;
  promotionTitle?: string;
  isNotInArea?: boolean;
  taxRate?: number | null;
  unitName?: string;
  supplierSysNo: string;
  tradeAgreementEntityList?: any[];
  priceWithoutTax?: number | null;
  skuDetail?: SkuDetail.PageMallSkuDetail;
  skuForPriceCalculate?: SkuForPriceCalculateInfo;
  choosen?: string;
  tradeAgreementSysNo?: string;
  selectTradeAgreement: TradeAgreementInfo;
  selectNetPriceType?: number | null;
  productStatus: ProductBuyStatusEnum;
  onSelectAgreement?: (agreement: any) => void;
  onUpdateProduct?: () => void;
  sellCountString?: string;
  isBuyable?: boolean;
  isOutSide?: boolean;
}) {
  const { showPrice, tip } = useContext(PriceContext);
  const { canView } = useRateAndSellCount();
  const [updatePriceLoading, setUpdatePriceLoading] = useState(false);
  const indexCodeSet =
    skuForPriceCalculate?.agreementPriceForm?.netPriceSourceInformation?.indexCodeSet;

  function renderTaxFreePrice() {
    const [integer, faction] = splitNum(priceWithoutTax);
    return (
      <Fragment>
        <span className="unit">￥</span>
        {priceWithoutTax != null ? (
          <Fragment>
            <span className="beforeInt">{integer}</span>.
            <span className="unit">
              {faction}/{unitName ?? ''}
            </span>
          </Fragment>
        ) : (
          <span className="beforeInt">--</span>
        )}
      </Fragment>
    );
  }

  const netPriceSourceInformation =
    skuForPriceCalculate?.agreementPriceForm?.netPriceSourceInformation;

  async function handleUpdatePrice() {
    setUpdatePriceLoading(true);
    const res = await updateLangeNetPrice(indexCodeSet);
    setUpdatePriceLoading(false);
    if (res.code === 200) {
      onUpdateProduct?.();
    }
  }
  console.log(showPrice, 'showPrice', tip, 'tip');
  return (
    <>
      <div className="basic">
        <div className="priceRow">
          {showPrice ? (
            <>
              {indexCodeSet?.length &&
                skuForPriceCalculate?.netPriceSource === NetPriceSourceEnum.LANGE && (
                  <Button
                    type="primary"
                    size="mini"
                    className="update-price-btn"
                    disabled={updatePriceLoading}
                    onClick={handleUpdatePrice}
                  >
                    <SyncOutlined />
                    <span className="update-price-btn-txt">更新网价</span>
                  </Button>
                )}

              <div className="afterPrice">
                {updatePriceLoading ? (
                  '正在获取网价…'
                ) : (
                  <>
                    <ProductDetailSalePrice
                      skuDetail={skuDetail}
                      selectTradeAgreement={selectTradeAgreement}
                      productStatus={productStatus}
                    />
                    <span className="calc-price-wrap">
                      {productStatus === 'Normal' &&
                      skuDetail.salesPrice &&
                      skuForPriceCalculate ? (
                        <CalculatePriceDetailWithIcon
                          skuName={skuDetail?.name}
                          skuMainImg={skuDetail?.mainImage}
                          skuModel={choosen}
                          skuForPriceCalculate={skuForPriceCalculate as any}
                          skuSysNo={skuDetail.sysNo + ''}
                          tradeAgreementSysNo={tradeAgreementSysNo}
                        />
                      ) : null}
                    </span>
                  </>
                )}
              </div>
              {!selectTradeAgreement?.sysNo && skuDetail.priceDesc && skuDetail.salesPrice ? (
                <div className="priceDesc">{skuDetail.priceDesc}</div>
              ) : null}
              {priceWithoutTax != null && !updatePriceLoading ? (
                <div className="beforePrice">
                  不含税价：
                  {renderTaxFreePrice()}
                  &nbsp;&nbsp;&nbsp;税率：{taxRate}%&nbsp;&nbsp;&nbsp;
                  {skuForPriceCalculate?.netPriceSource &&
                  skuForPriceCalculate?.netPriceSource !== NetPriceSourceEnum.BASE_PRICE ? (
                    <span>
                      {skuForPriceCalculate?.netPriceSource === NetPriceSourceEnum.INFO
                        ? '信息价：'
                        : skuForPriceCalculate?.netPriceSource === NetPriceSourceEnum.BASE
                        ? '基础价：'
                        : `${netPriceSourceInformation?.prefix ?? '网价'}：`}
                      <span className="rmb">￥</span>
                      {netPriceSourceInformation?.price == null
                        ? '--'
                        : netPriceSourceInformation.price + netPriceSourceInformation.suffix}
                    </span>
                  ) : null}
                  {netPriceSourceInformation?.publishDate && (
                    <span>
                      &nbsp;&nbsp;&nbsp;
                      {dateFormat(netPriceSourceInformation?.publishDate, 'M月DD日HH时mm分')}
                      发布
                    </span>
                  )}
                </div>
              ) : null}
            </>
          ) : (
            <div className="afterPrice">¥ {tip}</div>
          )}
          {isNotInArea ? <div className="noProduct">此商品不在该地区销售</div> : null}
          {canView && <span className="sellCount">销量{sellCountString}</span>}
        </div>
        <div className="titleRow">
          {skuDetail.titleProductTag?.[0] && (
            <span className="title-tag">{skuDetail.titleProductTag[0].tagName}</span>
          )}
          {skuDetail.skuType && <span className="title-lease-tag">租赁</span>}
          <h3>{name}</h3>
          <div className="sysNo">{skuDetail.sysNo}</div>
        </div>
        {promotionTitle && <div className="subTitle">{promotionTitle}</div>}
        {tradeAgreementEntityList?.filter((i) => i.tradeAgreementScope)?.length ? (
          <TradeAgreementPicker
            className="agreement-picker"
            supplierSysNo={supplierSysNo}
            tradeAgreementList={tradeAgreementEntityList}
            netPriceType={selectNetPriceType}
            onConfirm={(data) => {
              onSelectAgreement?.(data);
            }}
          />
        ) : null}
      </div>
      <style jsx>{`
        .basic {
          padding: 18px 0 0;
          box-sizing: border-box;
          background: #ffffff;
          margin-bottom: 10px;
          position: relative;
        }

        .basic :global(.update-price-btn) {
          position: absolute;
          right: 20px;
          top: 14px;
        }

        .update-price-btn-txt {
          margin-left: 6px;
        }

        .update-price-btn-txt {
        }

        .priceRow {
          padding: 0 16px;
          display: flex;
          justify-content: flex-start;
          align-items: baseline;
          flex-direction: column;
          position: relative;
        }

        .afterPrice {
          font-size: 15px;
          color: #ff6602;
          line-height: 18px;
        }

        .priceDesc {
          font-size: 12px;
          color: #ff6602;
          margin-top: 4px;
        }

        .beforePrice {
          font-size: 12px;
          color: #333333;
          font-weight: bold;
          margin-top: 8px;
          width: 100%;
          position: relative;
          line-height: 16px;
        }

        .beforePrice .unit {
          font-size: 10px;
        }

        .beforePrice .beforeInt {
          font-weight: bolder;
        }

        .calc-price-wrap {
          margin-left: 10px;
          vertical-align: bottom;
          position: relative;
        }

        .calc-price-wrap :global(.calcIcon) {
          position: absolute;
          top: 2px;
        }

        .noProduct {
          font-size: 11px;
          color: #666666;
          background: #f3f3f3;
          line-height: 16px;
          height: 16px;
          border-radius: 8px;
          padding: 0 10px;
          margin-top: 5px;
        }

        .titleRow {
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          padding: 13px 16px 14px;
        }

        .titleRow h3 {
          display: inline;
          word-break: break-all;
          line-height: 22px;
          font-weight: bold;
          color: #333;
        }

        .subTitle {
          font-size: 12px;
          color: #666666;
          letter-spacing: 0;
          line-height: 12px;
          padding: 0 16px;
          padding-bottom: 17px;
        }

        .basic :global(.agreement-picker .accountPeriod) {
          padding-right: 16px;
        }

        .basic :global(.agreement-picker .periodLabel) {
          background: #3b6dc7;
          border-radius: 10px;
          color: #fff;
          padding: 3px 7px;
          height: 20px;
          font-size: 12px;
          line-height: 14px;
        }

        .basic :global(.agreement-picker .period) {
          justify-content: space-between;
          margin-left: 11px;
        }

        .basic :global(.agreement-picker .periodVal) {
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          text-align: justify;
          line-height: 18px;
          text-overflow: ellipsis;
          word-break: break-all;
          overflow: hidden;
          display: block;
        }

        .basic :global(.agreement-picker .period svg) {
          margin-left: 15px;
          flex: 0 0 12px;
        }

        .basic :global(.agreement-picker .period svg path) {
          fill: #999;
        }

        .sellCount {
          position: absolute;
          font-size: 12px;
          color: #999999;
          right: 16px;
        }
        .title-tag {
          padding: 1px 4px;
          background: var(--primaryColor);
          border-radius: 1px;
          color: #fff;
          font-size: 12px;
          margin-right: 10px;
          transform: translateY(-3px);
          display: inline-block;
        }
        .title-lease-tag {
          padding: 1px 4px;
          background: #ffdf25;
          border-radius: 1px;
          font-size: 12px;
          margin-right: 10px;
          transform: translateY(-3px);
          display: inline-block;
        }
      `}</style>
    </>
  );
}

export default ProductDetailBasic;
